import template from './map.jade';
import iconTemplate from './map-icon.jade';

const getMapCenterByCoordsObj = ({ lat = 55.755814, lng = 37.617635 }) => {
  return [lat, lng];
};

export default angular.module('cian.addForm.feedbackMap', []).directive('cianAfFeedbackAddressMap', () => ({
  scope: {},
  bindToController: {
    geo: '=',
    isDisplayHint: '=',
  },
  controller: [
    'geoSelectorService',
    '$scope',
    'geoService',
    'telemetryService',
    function (geoSelectorService, $scope, geoService, telemetryService) {
      telemetryService.mark('addform.feedback-map-init-start');

      let onScopeDestroy = () => {};

      $scope.geoObjectProcessed = true;

      geoSelectorService.ready(ymaps => {
        const getCoordinates = () => {
          if (this.geo.coordinates) {
            return this.geo.coordinates;
          } else {
            return geoService.userGeo
              ? {
                  lat: geoService.userGeo.lat,
                  lng: geoService.userGeo.lng,
                }
              : {};
          }
        };

        const coordinates = getCoordinates();
        const centerMap = getMapCenterByCoordsObj(coordinates);

        this.createMap = () => {
          this.map = new ymaps.Map(
            $scope.feedbackMapElement[0],
            {
              center: centerMap,
              zoom: this.geo.zoom,
              controls: ['zoomControl'],
            },
            { suppressMapOpenBlock: true },
          );
          this.map.behaviors.disable('scrollZoom');

          const iconHtmlLayout = ymaps.templateLayoutFactory.createClass(iconTemplate);

          this.mark = new ymaps.Placemark(
            centerMap,
            {},
            {
              draggable: true,
              iconLayout: iconHtmlLayout,
              iconShape: {
                type: 'Circle',
                coordinates: [0, -24],
                radius: 22,
              },
              iconImageHref: require('../../../resources/assets/images/here.svg'),
            },
          );
          this.mark.events.add('dragend', this.dragEndMarker);

          this.jkMarkers = [];

          this.map.geoObjects.add(this.mark);

          // Обработчик изменения зума
          this.map.events.add('boundschange', e => {
            const newZoom = e.get('newZoom');
            const oldZoom = e.get('oldZoom');

            if (newZoom !== oldZoom) {
              this.geo.zoom = newZoom;
            }
          });

          this.map.events.add('click', e => {
            const coordinates = e.get('coords');

            this.setMarker(coordinates);
            this.isDisplayHint = false;
          });

          $scope.geoObjectProcessed = false;
        };

        this.setMarker = (coords, zoom = undefined) => {
          this.mark.geometry.setCoordinates(coords);

          if (zoom) {
            this.map.setZoom(zoom);
          }

          this.map.panTo(coords, { duration: 0, flying: false });
        };

        this.dragEndMarker = () => {
          const [lat, lng] = this.mark.geometry.getCoordinates();

          this.geo.coordinates = { lat, lng };
          this.isDisplayHint = false;
        };

        this.updateMap = coordinates => {
          if (coordinates.lat && coordinates.lng) {
            this.setMarker(getMapCenterByCoordsObj(coordinates), this.geo.zoom);
          }
        };

        this.createMap();

        const detachUpdateMap = $scope.$watch(
          () => this.geo.coordinates,
          (value, oldValue) => {
            if (value !== oldValue) {
              this.updateMap(value);
            }
          },
        );

        onScopeDestroy = () => {
          detachUpdateMap();
        };

        telemetryService.mark('addform.feedback-map-init-end');
        telemetryService.sendMeasuredTimer(
          'addform.feedback-map-init',
          'addform.feedback-map-init-start',
          'addform.feedback-map-init-end',
        );
      });

      $scope.$on('$destroy', () => {
        onScopeDestroy();
      });
    },
  ],
  controllerAs: 'feedbackMap',
  template,
  replace: true,
})).name;
